import { Form as FactorialForm } from 'factorial-form'

class BrandForm extends FactorialForm {
  constructor(values: {}) {
    super(values, {
      brand_color: 'string',
      header_font: 'string',
      body_font: 'string',
    })
  }
}

export default BrandForm
